import { type ColumnDef } from "@tanstack/react-table";

import { RowsLoading } from "../../RowsLoading";

type MobileTableLoadingProps<TData, TValue = unknown> = {
  columns: ColumnDef<TData, TValue>[];
};

export function MobileTableLoading<TData, TValue = unknown>({
  columns,
}: MobileTableLoadingProps<TData, TValue>) {
  return (
    <div
      className="border border-border/primary rounded-containerCorner overflow-hidden"
      data-testid="mobile-loading"
    >
      <table className="w-full">
        <RowsLoading columnsNumber={columns.length} />
      </table>
    </div>
  );
}
